import { IConfigsType } from '../../types'

const executiveScorecard: IConfigsType = {
  'fw_wingstop-scorecard-exa05evv': {
    '/:brand/scorecard': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/scorecard',
        height: '100vh',
      },
    },
  },
}

export default executiveScorecard
